import { createFileRoute } from "@tanstack/react-router";

import { ProfileSearch } from "@/components/profiles/search";
import { DefaultLayout } from "@/layouts/default";

export const Route = createFileRoute("/search")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DefaultLayout
      classNames={{ content: "w-full max-w-lg mx-auto py-6 px-3 md:py-12" }}
    >
      <ProfileSearch />
    </DefaultLayout>
  );
}
